import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd50ef10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Hint: notes for your change")

import { withDefaults, ref } from "vue";
import { TextArea as KTextArea } from "@progress/kendo-vue-inputs";
import { Hint as KHint } from "@progress/kendo-vue-labels";

//#endregion

type ModalProps = {
  show: boolean;
  title: string;
  readonly?: boolean;
};

//#region PROPS

const __default__ = {
  name: "BaseCommandModal",
  inheritAttrs: false,
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    show: { type: Boolean, default: false },
    title: null,
    readonly: { type: Boolean, default: false }
  },
  emits: ["note-changed", "close-modal"],
  setup(__props: any, { emit }) {

const props = __props as { show: boolean, title: string, readonly: boolean }

//#region IMPORTS

//#endregion

//#region EMITS

//#endregion

const notes = ref("");

//#region EVENT HANDLERS
const onClose = (event: PointerEvent): void => {
  const target = event.target as HTMLInputElement;

  if (target.className == "modal-wrapper") emit("close-modal");
};

const onNoteChange = (event: any): void => {
  emit("note-changed", event.value);
};
//#endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (_ctx.$props.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-background",
            onClick: onClose
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("header", null, [
                  _createElementVNode("h1", _hoisted_3, _toDisplayString(props.title), 1)
                ]),
                _createElementVNode("main", null, [
                  _renderSlot(_ctx.$slots, "main")
                ]),
                _createElementVNode("footer", null, [
                  (!__props.readonly)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                        _createVNode(_unref(KTextArea), {
                          value: notes.value,
                          onChange: onNoteChange
                        }, null, 8, ["value"]),
                        _createVNode(_unref(KHint), null, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _renderSlot(_ctx.$slots, "footer")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})